import React, { FunctionComponent } from 'react'
import { Trans, useTranslation } from 'next-i18next'
import { useCheckoutSizes } from '../../../utils/responsive'
import { ColorTypes, DesignLanguage, Text, Theme, TypoFontFace, useIsDesignLanguage, useIsTheme } from '@afterpaytouch/core'
import styles from './style.module.css'
import { TermLink } from '../../TermLink'
import { TransProps } from 'react-i18next'

interface TermLinkDefaultProps {
  color?: ColorTypes
  fontFace?: TypoFontFace
}

export const Terms: FunctionComponent = () => {
  const { t } = useTranslation()
  const { extraSmallTextSize } = useCheckoutSizes()
  const isArcadeDesignLanguage = useIsDesignLanguage(DesignLanguage.Arcade)
  const isPegasusTheme = useIsTheme(Theme.Pegasus)

  const getTranslation = (): TransProps<string> => {
    const termLinkDefaultProps: TermLinkDefaultProps = {
      color: isPegasusTheme ? 'Prominent' : 'Info',
      fontFace: 'CashSansMono',
    }

    const keyGen = (suffix: string) => `payment-types-pbi-rejected-${suffix}`

    const consentUrl = `${t('consumerLending:termsOfServiceUrl')}#e-sign`
    const creditReportUrl = `${t('consumerLending:termsOfServiceUrl')}#credit-check`
    const components = {
      creditReportAuthorization: <TermLink {...termLinkDefaultProps} key={keyGen('credit-report')} href={creditReportUrl} />,
      eSignConsent: <TermLink {...termLinkDefaultProps} key={keyGen('esign-consent')} href={consentUrl} />,
      apPrivacyPolicy: <TermLink {...termLinkDefaultProps} key={keyGen('ap-privacy-policy')} href={t('common:privacyPolicyUrl')} />,
      fePrivacyPolicy: <TermLink {...termLinkDefaultProps} key={keyGen('fe-privacy-policy')} href={t('consumerLending:febPrivacyPolicyUrl')} />,
      termsOfService: <TermLink {...termLinkDefaultProps} key={keyGen('terms-of-service')} href={t('consumerLending:termsOfServiceUrl')} />,
    }

    return { i18nKey: 'consumerLending:paymentTypesB:terms', components }
  }

  return (
    <div className={styles.PBIRejectedTermsWrapper}>
      <Text color={isArcadeDesignLanguage ? 'Neutral 500' : 'Neutral 600'} size={isArcadeDesignLanguage ? 'XXS' : extraSmallTextSize} fontFace='CashSansMono'>
        <Trans {...getTranslation()} />
      </Text>
    </div>
  )
}
